import React from "react";
import { useQuery } from "react-query";
import { getCustomQuery } from "../../../../actions/Utilities/CustomReport";

const useGetCustomQuery = (columns: any, isQueryClick: boolean) => {
  return useQuery(["GetCustomQuery"], () => getCustomQuery(columns), {
    refetchOnWindowFocus: false,
    enabled: isQueryClick,
  });
};
export default useGetCustomQuery;
